// Interfaces
import { IRouteParent } from 'routes/route.interface'

// Routes
import { assessmentRoutes as assessmentIndexRoutes } from './assessment.router'

// Constant
import { ASSESSMENT_URL, ASSESSMENT_MODULE } from 'constant/url.constant'
import { ACCESS_CODE_LIST_OF_ASSESSMENT } from 'constant/access.constant'

const assessmentRoutes: IRouteParent = {
  path: ASSESSMENT_URL.INDEX,
  meta: {
    attrs: {
      module: ASSESSMENT_MODULE,
      icon: 'back-office/icon-history',
      label: 'assessment.listOfAssessment',
      accessCodes: ACCESS_CODE_LIST_OF_ASSESSMENT,
    },
  },
  children: [...assessmentIndexRoutes],
}

export { assessmentRoutes }
